import { Centrale } from '@urbasolar_dev/urbaconnect-types'

import { useDashboardApi } from '../../infrastructure/api/useDashboardApi'
import { GRAPH_VIEW } from '../../domain/enums/dashboard.enum'

export const useDashboardUseCase = () => {
  const { getSalesRevenue, getDataExpectedProduction, getDataProduction } = useDashboardApi()
  return {
    getDataProduction: async (
      start: number,
      end: number,
      graphView: GRAPH_VIEW,
      selectedPlant: Centrale | null
    ) => {
      return getDataProduction(start, end, graphView, selectedPlant)
    },
    getDataExpectedProduction: async (
      start: number,
      end: number,
      selectedPlant: Centrale | null
    ) => {
      return getDataExpectedProduction(start, end, selectedPlant)
    },
    getSalesRevenue: async (start: number, end: number, selectedPlant: Centrale | null) => {
      return getSalesRevenue(start, end, selectedPlant)
    },
  }
}
